// localStorage keys
export const USERNAME_KEY = 'username';
export const JWT_TOKEN_KEY = 'token';
export const POPULATION_KEY = 'population';
export const USER_API_KEY_KEY = 'api_key';

export const POPULATION_SIZE = 8;
export const BACKEND_PORT = 5000;

export const mutationModes = ['word', 'phrase', 'clause', 'macromutation'];
export const mutationPositions = ['near the beginning', 'the middle', 'near the end'];

export const TILE_SIZE = '256px';

export const REGISTER_ID_PARAM_NAME = 'regId';

// can probably use .env.local for dev server configuration of ports, etc
// see https://stackoverflow.com/questions/49108136/importing-env-variable-react-front-end
